import { render, staticRenderFns } from "./VProjectEdit.vue?vue&type=template&id=e28660d0&"
import script from "./VProjectEdit.vue?vue&type=script&lang=js&"
export * from "./VProjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports